import { partnerSupabase } from "Infrastructure/Supabase/partnerSupabaseClient";
import type { PartnershipRecord } from "Order/Modules/MorningCheck/Api/Query/usePartnershipRecordsQuery";
import { useQuery } from "@tanstack/react-query";

export const ALL_PARTNERSHIP_RECORDS_KEY = "ALL_PARTNERSHIP_RECORDS";

const PAGE_SIZE = 50;

export type ActionTypeFilter =
	| "connection"
	| "job_start"
	| "completion"
	| "examination"
	| "";
export type StatusFilter = "positive" | "negative" | "";
export type SortOrder = "newest" | "oldest";

const POSITIVE_ACTIONS = ["connected", "started", "finished", "examined"];
const NEGATIVE_ACTIONS = [
	"not_connected",
	"not_started",
	"not_finished",
	"not_examined",
];

export interface PartnershipRecordsFilters {
	actionType: ActionTypeFilter;
	status: StatusFilter;
	sortOrder: SortOrder;
}

export const useAllPartnershipRecordsQuery = (
	page: number,
	filters: PartnershipRecordsFilters,
) =>
	useQuery({
		queryKey: [ALL_PARTNERSHIP_RECORDS_KEY, page, filters],
		queryFn: async () => {
			const from = page * PAGE_SIZE;
			const to = from + PAGE_SIZE - 1;

			let query = partnerSupabase
				.from("partnership_records")
				.select(
					"id, order_id, action_type, status, reason, note_for_adam, action, file_path, country, created_at",
					{ count: "exact" },
				);

			if (filters.actionType) {
				query = query.eq("action_type", filters.actionType);
			}

			if (filters.status === "positive") {
				query = query.in("action", POSITIVE_ACTIONS);
			} else if (filters.status === "negative") {
				query = query.in("action", NEGATIVE_ACTIONS);
			}

			query = query
				.order("created_at", { ascending: filters.sortOrder === "oldest" })
				.range(from, to);

			const { data, error, count } = await query;

			if (error) {
				throw error;
			}

			return {
				records: (data as PartnershipRecord[]) ?? [],
				totalCount: count ?? 0,
				pageSize: PAGE_SIZE,
			};
		},
		refetchInterval: 30_000,
	});
